<template>
        <div class="flex xs12 sm12 md12 lg12 xl9 reset-password" v-resize="resizeHandler">
                <div class="l-side flex xs12 sm12 md12 lg5 xl5">
                    <div class="form-l">
                        <div class="form-l__inner">
                            <BackButton defaultText="back-to-sign-in" defaultRoute="/members/sign-in"/>
                            <div class="form-l__title">
                                <h4 class="title-h4">
                                    {{ $t("members.reset-password.title") }}
                                </h4>
                            </div>
                            <div class="form-l__content">
                                <p>
                                    {{ $t("members.reset-password.sub1") }}
                                </p>
                                <p>
                                    {{ $t("members.reset-password.sub2") }}
                                </p>
                            </div>
                            <div class="form-l__body">
                                <form class="form" @submit.prevent="submitHandler">
                                    <div class="form__row">
                                        <div class="form__row-title ">
                                            {{ $t("form.email_address") }}
                                        </div>
                                        <div class="form__row-field">
                                            <textField
                                                    v-model.trim="resetPassword.email"
                                                    :v="$v.resetPassword.email"
                                                    :placeholder="$t('form.email')"
                                                    type="text"
                                                    :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                            />
                                        </div>
                                    </div>
                                    <div class="form__action">
                                        <button type="submit" class="btn btn-w100 btn-gradient">
                                            <span> {{ $t("form.apply_password") }}</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
</template>


<script>
    import textField from "@/elements/textField";
    import validate from "@/mixins/validate";
    import resize from "@/mixins/resize";
    export default {
        mixins: [validate, resize],
        components: {
            textField
        },
        data() {
            return {
                resetPassword: {
                    email: ''
                }
            }
        },
        methods: {
            async submitHandler() {
                this.$v.resetPassword.$touch();
                if (!this.$v.resetPassword.$invalid) {
                    let email = this.resetPassword.email;
                    let data = await this.$store.dispatch('CLIENT_RESET_PASSWORD', {email: email})
                    if(data && data.status === 200) {
                        localStorage.setItem('reset_email', email)
                        this.$router.push('/members/reset-password-sent')
                    }
                }
            },
        }
    }
</script>

<style lang="sass" scoped>
    .reset-password
        +r(1023)
            .l-side
                display: flex
                justify-content: center


    .form-l__title
        margin-top: 36px

</style>